<img [src]="baseUrl$ | async" />
<img src="" />
<img
  [ngStyle]="{ 'mix-blend-mode': mixBlendMode.value, opacity: a }"
  [src]="maskPng$ | async"
  class="mask"
  />
  @if (showSample) {
    <img [src]="sampleUrl$ | async" class="sample" />
  }
  <svg>
    <defs>
      <filter color-interpolation-filters="sRGB" id="colorize">
        <feColorMatrix
          type="matrix"
        values="1 0 0 0 .255
               0 0 0 0 .0
               0 0 0 0 .0
               0 0 0 1 0"
          />
        </filter>
      </defs>
    </svg>
    @if (showMenu$ | async) {
      <div class="menu">
        <div>
          Zdjęcie
          <input (change)="loadMainImage($event)" type="file" />
        </div>
        <div>
          Maska
          <input (change)="loadMaskImage($event)" type="file" />
        </div>
        <h1>Kolor</h1>
        <mat-form-field>
          <mat-label>Mieszanie</mat-label>
          <mat-select [formControl]="mixBlendMode">
            <mat-option value="normal">normal</mat-option>
            <mat-option value="multiply">multiply</mat-option>
            <mat-option value="screen">screen</mat-option>
            <mat-option value="overlay">overlay</mat-option>
            <mat-option value="darken">darken</mat-option>
            <mat-option value="lighten">lighten</mat-option>
            <mat-option value="color-dodge">color-dodge</mat-option>
            <mat-option value="color-burn">color-burn</mat-option>
            <mat-option value="hard-light">hard-light</mat-option>
            <mat-option value="soft-light">soft-light</mat-option>
            <mat-option value="difference">difference</mat-option>
            <mat-option value="exclusion">exclusion</mat-option>
            <mat-option value="hue">hue</mat-option>
            <mat-option value="saturation">saturation</mat-option>
            <mat-option value="color">color</mat-option>
            <mat-option value="luminosity">luminosity</mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <input (change)="loadSample($event)" type="file" />
        </div>
        <div>
          <mat-checkbox [(ngModel)]="showSample">Pokaż sample</mat-checkbox>
        </div>
        <input
          [(colorPicker)]="color"
          [style.background]="color"
          cpOutputFormat="rgba"
          />
        </div>
      }
